// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2ooyu","info":"PatientInfo_info__AgRhx"};